<template>
  <transition name="slide-right">
    <b-container>
      <b-row class="mt-5 justify-content-center">
        <b-col md="6">
          <h2 class="text-muted">
            <font-awesome-icon icon="user-plus" class="h5 float-right" />Add new
            dashboard user
          </h2>
        </b-col>
      </b-row>
      <NewUser />
    </b-container>
  </transition>
</template>
<script>
import NewUser from "@/components/NewUser.vue";
export default {
  components: { NewUser },
};
</script>
